<div class="verification-dialog">
  <div class="dialog-header">
    <button
      *ngIf="data.type === 'signUp'"
      class="back-btn"
      (click)="goBackToSignup()">
      <i class="fa-solid fa-arrow-left"></i>
    </button>
    <h4>{{ "verification" | translate }}</h4>
    <span class="close-icon" mat-dialog-close>
      <i class="fa-regular fa-circle-xmark"></i>
    </span>
  </div>
  <div class="dialog-body">
    <p class="verification-subtitle">
      {{ "verificationCode" | translate }}
      <span *ngIf="data.phoneNo && data.isVerifyingPhone" class="contact-info">
        {{ data.phoneNo ? data.dialCode + "-" + data.phoneNo : data.email }}
      </span>
      <span *ngIf="data.email && data.isVerifyingEmail" class="contact-info">
        {{ data.email }}
      </span>
    </p>

    <div class="otp-wrapper">
      <megastore-otp
        (otp)="fetchOtp($event)"
        [length]="data.length || 4"></megastore-otp>
    </div>

    <button type="button" (click)="handleDialog()" class="submit-btn">
      {{ "submit" | translate }}
    </button>

    <p class="timer-text" *ngIf="!sendAgain">
      {{ "codeExpire" | translate }} {{ formatTimer(otpTimer) }}
    </p>

    <p class="resend-link" *ngIf="sendAgain">
      <a type="button" (click)="resendOtp()">
        {{ "resendCode" | translate }}
      </a>
    </p>
  </div>
</div>
